/**
 * Bootstrap configuration for webpack 4 (production)
 * Same as dev - MiniCssExtractPlugin handles extraction in webpack config
 */

import './variables.scss';
import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss';
import './bootstrap.overrides.scss';

